export function toTextCurrency(value: number|string|null, secureValue: boolean = false) {
    if (secureValue) {
        return 'R$ ***';
    }
    
    if (value === null || value === undefined) {
        return "";
    }
    
    const numValue = Number(value);
    
    if (isNaN(numValue)) {
        return "";
    }
    
    // Formatação reduzida
    if (Math.abs(numValue) >= 1000000) {
        // Milhões
        const millions = numValue / 1000000;
        // Se for um número inteiro, não mostra decimais
        if (millions % 1 === 0) {
            return `${millions}M`;
        }
        // Caso contrário, mostra 1 casa decimal
        return `${millions.toFixed(1)}M`;
    } else if (Math.abs(numValue) >= 1000) {
        // Milhares
        const thousands = numValue / 1000;
        // Se for um número inteiro, não mostra decimais
        if (thousands % 1 === 0) {
            return `${thousands}k`;
        }
        // Caso contrário, mostra 1 casa decimal
        return `${thousands.toFixed(1)}k`;
    }
    
    // Valores menores que 1000 retornam como estão
    return numValue.toString();
}

export default function toCurrency(value: number|string|null, secureValue: boolean = false) {
    if (secureValue) {
        return 'R$ ***';
    }
    
    return Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(Number(value));
}